var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComputerPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3A414C",
  strokeWidth: 1.621,
  d: "M1 3.251A2.25 2.25 0 0 1 3.251 1H17.75A2.25 2.25 0 0 1 20 3.251v8.165a2.25 2.25 0 0 1-2.251 2.25H3.25A2.25 2.25 0 0 1 1 11.417z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3A414C",
  strokeLinecap: "round",
  strokeWidth: 1.621,
  d: "M7.27 15.883h6.84"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 12,
  r: 4,
  fill: "#F7F8F8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3A414C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m19 10 2.667 2L19 14z"
})));
export { SvgComputerPlay as ReactComponent };
export default __webpack_public_path__ + "static/media/computerPlay.bf070477.svg";